import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd';
import moment from 'moment';
import format from '../../lib/formatDate';
import React from 'react';

interface AuditDatesPickerProps {
  eventsStartDate: string;
  eventsEndDate: string;
  setEventsStartDate: (date: string) => void;
  setEventsEndDate: (date: string) => void;
}

const AuditDatesPicker = ({
  eventsStartDate,
  eventsEndDate,
  setEventsStartDate,
  setEventsEndDate
}: AuditDatesPickerProps) => {
  const { t } = useTranslation('common');
  return (
    <div style={styles.container}>
      <div style={styles.datesContainer}>
        <div>{t('From:')}</div>
        <DatePicker
          data-testid="audit-dates-picker-from"
          defaultValue={moment(eventsStartDate, 'YYYY-MM-DD')}
          placeholder={t('From:')}
          format="DD-MM-YYYY"
          onChange={(date, ds) => {
            const formatIfArray = ds && Array.isArray(ds) ? ds[0] : ds;
            const newDate = ds ? format(moment(formatIfArray, 'DD-MM-YYYY').toDate(), 'yyyy-MM-dd') : '';
            setEventsStartDate(newDate);
          }}
        />
        <div>{t('To:')}</div>
        <DatePicker
          data-testid="audit-dates-picker-to"
          defaultValue={moment(eventsEndDate, 'YYYY-MM-DD')}
          placeholder={t('To:')}
          format="DD-MM-YYYY"
          onChange={(date, ds) => {
            const formatIfArray = ds && Array.isArray(ds) ? ds[0] : ds;
            const newDate = ds ? format(moment(formatIfArray, 'DD-MM-YYYY').toDate(), 'yyyy-MM-dd') : '';
            setEventsEndDate(newDate);
          }}
        />
      </div>
      <p style={styles.datesErrorMessage}>{t('Period should be less than 14 days')}</p>
    </div>
  );
};

export default AuditDatesPicker;

const styles = {
  container: {
    marginBottom: '1rem'
  },
  datesContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.7rem',
    marginBottom: '0.5rem'
  },
  datesErrorMessage: {
    display: 'flex',
    justifyContent: 'center'
  }
};
